import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Body } from '@vds-core/typography';
import { ColorTokens } from '@vds-tokens/color';
import { LayoutTokens } from '@vds-tokens/layout';
var propTypes = {
  selected: PropTypes.bool,
  children: PropTypes.string.isRequired
};
var defaultProps = {
  selected: false
};
var StyledBreadcrumbSpan = /*#__PURE__*/styled(Body).withConfig({
  displayName: "StyledBreadcrumbSpan",
  componentId: "VDS__sc-1hgr4wl-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: default;\n  transition: color 0.15s ease-out;\n  padding-bottom: ", ";\n"])), LayoutTokens.space['3X'].value);
/**
 * @ignore
 */

var BreadcrumbSpan = function BreadcrumbSpan(_ref) {
  var selected = _ref.selected,
      children = _ref.children,
      surface = _ref.surface,
      ariaLabel = _ref.ariaLabel,
      analyticsTrack = _ref['data-analyticstrack'],
      track = _ref['data-track'],
      trackIgnore = _ref['data-track-ignore'],
      clickStream = _ref['data-clickstream'];

  function color() {
    if (selected && surface !== 'dark') return ColorTokens.elements.primary.onlight.value;else if (selected && surface === 'dark') return ColorTokens.elements.primary.ondark.value;else return surface === 'dark' ? ColorTokens.elements.secondary.ondark.value : ColorTokens.elements.secondary.onlight.value;
  }

  return /*#__PURE__*/React.createElement(StyledBreadcrumbSpan, {
    bold: selected,
    "aria-label": ariaLabel,
    "aria-selected": selected,
    "aria-current": selected ? 'page' : null,
    selected: selected,
    primitive: "span",
    size: "small",
    color: color(),
    "data-analyticstrack": analyticsTrack,
    "data-track": track,
    "data-track-ignore": trackIgnore,
    "data-clickstream": clickStream
  }, children);
};

BreadcrumbSpan.propTypes = propTypes;
BreadcrumbSpan.defaultProps = defaultProps;
export default BreadcrumbSpan;